import { alpha } from '@mui/material';
import { MarkAreaComponentOption } from 'echarts';
import {
  AQI_LEVELS,
  AQI_LEVELS_COLORS,
  AQI_LEVELS_LOWER_BOUNDS,
  AQI_CHART_LEVELS_TO_TRANSLATION_KEYS,
} from 'features/aqiSensors/aqiSensors.constants';
import { AQISensorObservation } from 'features/aqiSensors/aqiSensors.types';
import { TFunction } from 'i18next';

export const observationToSeriesData = ({
  timestamp,
  aqi,
}: AQISensorObservation): [Date, number] => [timestamp, aqi];

export const getChartBounds = (
  observations: AQISensorObservation[],
): { upperBounds: number; lowerBounds: number } => {
  const aqiValues = observations.map((obs) => obs.aqi);
  const highestValue = Math.max(...aqiValues);

  const upperBounds = Math.max(highestValue, 350);
  const lowerBounds = 0;

  return { upperBounds, lowerBounds };
};

export const getLevelsMarkAreaData = (
  t: TFunction,
  upperBounds: number,
): MarkAreaComponentOption['data'] => {
  const levels = Object.values(AQI_LEVELS);

  return levels.map((level, index) => {
    const min = AQI_LEVELS_LOWER_BOUNDS[level];
    const max =
      index < levels.length - 1
        ? AQI_LEVELS_LOWER_BOUNDS[levels[index + 1]] - 1
        : upperBounds;

    return [
      {
        name: t(AQI_CHART_LEVELS_TO_TRANSLATION_KEYS[level]),
        yAxis: min,
        itemStyle: {
          color: alpha(AQI_LEVELS_COLORS[level], 0.5),
        },
      },
      {
        yAxis: max,
      },
    ];
  });
};
